import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Chip,
  Divider,
  ListItemIcon,
  ListItemText,
  Alert
} from '@mui/material';
import {
  DirectionsCar as DirectionsCarIcon,
  AccountCircle as AccountCircleIcon,
  Logout as LogoutIcon,
  Group as GroupIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import ManageUsersDialog from '../VehicleLog/Dialogs/ManageUsersDialog';

const UserHeader = () => {
  const { user, logout, clienteInfo } = useAuth();
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [manageUsersOpen, setManageUsersOpen] = useState(false);

  const handleUserMenuClick = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };


  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const handleLogout = () => {
    logout();
    handleUserMenuClose();
  };

  const handleOpenManageUsers = () => {
    setManageUsersOpen(true);
    handleUserMenuClose();
  };

  const getUserRole = (role) => {
    const roles = {
      "guard": "Seguridad",
      "admin": "Administrador",
      "supervisor": "Supervisor",
      "operator": "Operador"
    }
    return roles[role]
  };

  return (
    <AppBar 
      position="static" 
      sx={{ 
        background: '#282626ff',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            borderRadius: 0
      }}
    >
      <Toolbar>       
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2, marginLeft: "2rem" }}>
        <Box
            component="img"
            src="ParkeyLogoWhite.svg" 
            alt="Bitácora Digital"
            sx={{
              height: '120px',
              width: 'auto',
              objectFit: "contain",
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.15))",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.02)",
              },
            }}
          />
          {(clienteInfo?.nombre || process.env.REACT_APP_NOMBRE_CONJUNTO) && (
            <Chip
              label={clienteInfo?.nombre || process.env.REACT_APP_NOMBRE_CONJUNTO}
              size="small"
              sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 600 }}
            />
          )}
        </Box>
                          
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          {/* Información del Usuario */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ textAlign: 'right', mr: 1 }}>
              <Typography variant="body2" sx={{ opacity: 0.9, lineHeight: 1.2 }}>
                {user?.name} {user?.lastname}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.7 }}>
                {getUserRole(user?.role)}
              </Typography>
            </Box>
            
            <Avatar 
              onClick={handleUserMenuClick}
              sx={{ 
                width: 40, 
                height: 40,
                bgcolor: 'rgba(255,255,255,0.2)',
                cursor: 'pointer',
                border: '2px solid rgba(255,255,255,0.3)',
                '&:hover': { 
                  bgcolor: 'rgba(255,255,255,0.3)',
                  border: '2px solid rgba(255,255,255,0.5)'
                }
              }}
            >
              {user?.name?.charAt(0)}{user?.lastname?.charAt(0)}
            </Avatar>
          </Box>

          {/* Menú de Usuario */}
          <Menu
            anchorEl={userMenuAnchor}
            open={Boolean(userMenuAnchor)}
            onClose={handleUserMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                mt: 1.5,
                minWidth: 220,
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
              }
            }}
          >
            {/* <Box sx={{ p: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {user?.name} {user?.lastname}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {getUserRole(user?.role)}
              </Typography>
            </Box>
            
            <Divider />
            
            <MenuItem onClick={handleUserMenuClose}>
              <ListItemIcon>
                <AccountCircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Mi Perfil</ListItemText>
            </MenuItem>
            
            <MenuItem onClick={handleUserMenuClose}>
              <ListItemIcon>
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Configuración</ListItemText>
            </MenuItem>
            
            <Divider /> */}
            <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Cerrar Sesión</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
      
      <ManageUsersDialog
        open={manageUsersOpen}
        onClose={() => setManageUsersOpen(false)}
      />

    </AppBar>
  );
};

export default UserHeader;